export default __webpack_public_path__ + "static/media/15c6dd6beae3ffcb58c2341b39712674.png";